import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=f6f28f48"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports